var _rect, _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgKey = function SvgKey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#FDEBDA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m40.523 31.442-2.988-2.986 2.784-2.785 2.988 2.989a1.969 1.969 0 0 0 2.784-2.784l-2.987-2.99 1.39-1.386a1.97 1.97 0 0 0-2.782-2.79L27.587 32.834a6.89 6.89 0 1 0 2.785 2.783l4.384-4.378 2.983 2.992a1.97 1.97 0 0 0 3.212-.64 1.968 1.968 0 0 0-.428-2.145v-.004Z",
    stroke: "#EF7B0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24.325 41.342a2.46 2.46 0 1 0 0-4.922 2.46 2.46 0 0 0 0 4.922Z",
    stroke: "#EF7B0E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

export default SvgKey;